import { render, staticRenderFns } from "./HodoProDetail.vue?vue&type=template&id=c70e61be&scoped=true"
import script from "./HodoProDetail.vue?vue&type=script&lang=js"
export * from "./HodoProDetail.vue?vue&type=script&lang=js"
import style0 from "./HodoProDetail.vue?vue&type=style&index=0&id=c70e61be&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70e61be",
  null
  
)

export default component.exports